/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Controls_LabelInputs */

const en_position_controls_label = /** @type {(inputs: Position_Controls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position controls`)
};

const fr_position_controls_label = /** @type {(inputs: Position_Controls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controles de position`)
};

const de_position_controls_label = /** @type {(inputs: Position_Controls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positionssteuerungen`)
};

const it_position_controls_label = /** @type {(inputs: Position_Controls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controlli di posizione`)
};

const ru_position_controls_label = /** @type {(inputs: Position_Controls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Позиционные элементы управления`)
};

const es_position_controls_label = /** @type {(inputs: Position_Controls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controles de posición`)
};

const zh_cn2_position_controls_label = /** @type {(inputs: Position_Controls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置控制`)
};

const ja_position_controls_label = /** @type {(inputs: Position_Controls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置コントロール`)
};

const hi_position_controls_label = /** @type {(inputs: Position_Controls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थिति नियंत्रण`)
};

const pt_pt2_position_controls_label = /** @type {(inputs: Position_Controls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controles de posição`)
};

/**
* | output |
* | --- |
* | "Position controls" |
*
* @param {Position_Controls_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_controls_label = /** @type {((inputs?: Position_Controls_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Controls_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_position_controls_label(inputs)
	if (locale === "de") return de_position_controls_label(inputs)
	if (locale === "it") return it_position_controls_label(inputs)
	if (locale === "ru") return ru_position_controls_label(inputs)
	if (locale === "es") return es_position_controls_label(inputs)
	if (locale === "zh-CN") return zh_cn2_position_controls_label(inputs)
	if (locale === "ja") return ja_position_controls_label(inputs)
	if (locale === "hi") return hi_position_controls_label(inputs)
	if (locale === "pt-PT") return pt_pt2_position_controls_label(inputs)
	return en_position_controls_label(inputs)
});